import WrapperNavHero from "../components/landing/wrapper-nav-hero";
import Description from "../components/landing/description";
import Overview from "../components/landing/overview";
import Footer from "../components/landing/footer";
import CTA from "../components/landing/cta";

export default function Landing() {
  return (
    <>
      <WrapperNavHero />
      <Description />
      <div className="flex w-full border-t border-gray-100/10 [border-width:0.5px]" />
      <Overview />
      <CTA />
      <div className="flex w-full border-t border-gray-100/10 [border-width:0.5px]" />
      <Footer />
    </>
  );
}
